export const environment = {
    production: false,
    context: 'dev',
    apiURL: 'https://mrtstatereportingapi-dev.azurewebsites.net',
    // apiURL: 'https://localhost:59306',
    versionNumber: '1.0.0|10/09/2024',
    versionPollTime: 10, // in minutes
};